module.exports = __webpack_public_path__ + "static/img/solve.67e7ee0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/solve.jpg
// module id = nsAl
// module chunks = 1